import { getVueTemplate } from "../../_imports/utils/utils.common";
import FormsBaseField from "./_imports/forms-base-field.vue";
import FormsCheckboxField from "./forms-checkbox-field.vue";

export default {
	name: 'forms-disclaimer-field',
	template: getVueTemplate('forms-disclaimer-field'),
	mixins: [
		FormsBaseField
	],
	components: {
		FormsCheckboxField
	},
	props: {
		validDisclaimer: Object
	},
	data() {
		return {
			checkboxIsChecked: false,
			isVisible: false
		}
	},
	watch: {
		isVisible() {
			if (!this.field.checkboxText) {
				this.ignore = false;
			} else {
				this.ignore = !this.isVisible;
			}

			this.userInput = '';
		},
		userInput() {
			this.updateState(state => state.userInput = this.userInput);
			this.validateField();
		},
		validDisclaimer() {
			if (this.validDisclaimer) {
				this.isVisible = this.validDisclaimer.disclaimerIndex === this.field.disclaimerIndex;
			}
		}
	},
	methods: {
		onCheckboxStateUpdate(checkboxState) {
			this.checkboxIsChecked = checkboxState.userInput;
			this.userInput = this.checkboxIsChecked;
		},
		onCreated() {
			this.ignore = true;
			this.updateState(state => state.name = 'optInOnForm');
		}
	}
};